import { render, staticRenderFns } from "./interventiondetail.vue?vue&type=template&id=8ee63a74&scoped=true&"
import script from "./interventiondetail.vue?vue&type=script&lang=js&"
export * from "./interventiondetail.vue?vue&type=script&lang=js&"
import style0 from "./interventiondetail.vue?vue&type=style&index=0&id=8ee63a74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee63a74",
  null
  
)

export default component.exports